module.exports = __webpack_public_path__ + "fonts/memnYaGs126MiZpBA-UFUKXGUdhlIqOjjg.f6d49f28.woff2";